import { render, staticRenderFns } from "./UseCasesDetails.vue?vue&type=template&id=70ea55bc&scoped=true&"
import script from "./UseCasesDetails.vue?vue&type=script&lang=js&"
export * from "./UseCasesDetails.vue?vue&type=script&lang=js&"
import style0 from "./UseCasesDetails.vue?vue&type=style&index=0&id=70ea55bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea55bc",
  null
  
)

export default component.exports